import { Component } from '@angular/core';
import { ApiService } from 'app/api.service';
import { AppService } from 'app/app.service';
import { Pagination } from 'app/shared/pagination';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';

@Component({
	selector: 'modal-quote-select-lines-by-product',
	templateUrl: './modal-quote-select-lines-by-product.component.html'
})
export class ModalQuoteSelectLinesByProductComponent extends UIModalBaseComponent {

	quoteId = null;
	list: any[] = null;
	search = '';
	pagination = new Pagination();
	selectedLines = 0;
	// 'lines' (default): multi-select lines, closes with number[] of line ids.
	// 'image': single-click a product to pick its image, closes with { image_id, image_url }.
	mode: 'lines' | 'image' = 'lines';

	constructor(
		public app: AppService,
		private api: ApiService
	) {
		super();
	}

	open(data: any = null) {
		this.search = '';
		this.quoteId = data.quoteId;
		this.mode = data.mode === 'image' ? 'image' : 'lines';
		this.selectedLines = 0;
		this.list = null;

		this.refresh();

		this.modal.open();
	}

	refresh() {
		this.api.quote.linesByProduct(this.quoteId, list => {
			// Image mode: only offer products that actually have an image.
			this.list = this.mode === 'image' ? list.filter(i => i.image_id) : list;
		});
	}

	selectItem(item) {
		// Image mode: one click on a product that has an image returns it and closes.
		if (this.mode === 'image') {
			if (item.image_id) this.modal.close({ image_id: item.image_id, image_url: item.image_url });
			return;
		}

		item.selected = !item.selected;

		this.selectedLines = 0;
		this.list.forEach(i => {
			if (i.selected) this.selectedLines += i.line_count;
		});
	}

	selectLinesButton() {
		const selected = [];

		this.list.forEach(item => {
			if (item.selected) {
				const ids = ('' + item.line_ids).split(',');
				ids.forEach(id => { selected.push(parseInt(id, 10)); });
			}
		});

		this.modal.close(selected);
	}

}
